import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useBrand } from '@/shared/brand/useBrand';
import { EmptyState } from '@/shared/components/EmptyState';
import { useT } from '@/shared/i18n/useT';

export function NotFound() {
  const t = useT();
  const brand = useBrand();
  const title = t('common.notFoundTitle');

  useEffect(() => {
    document.title = `${title} · ${brand.name}`;
  }, [title, brand.name]);

  return (
    <div className="py-6 sm:py-8">
      <EmptyState
        headingLevel={1}
        icon="home"
        title={title}
        body={t('common.notFoundBody')}
        action={
          <Link
            to="/"
            className="tap-target inline-flex items-center rounded-token bg-accent px-4 py-2 text-sm font-medium text-accent-fg hover:bg-accent-hover"
          >
            {t('common.goHome')}
          </Link>
        }
      />
    </div>
  );
}
